import * as React from "react";
import { useCurrentStudyConfigurationContext } from "../../../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../../../Core/SecurityContext";
import { PermissionEnum } from "../../../../misc/api/ApiPermissionEnum";
import { Authorization } from "../../../../misc/components/Authorization";

export const MiscCorrectionItem = ({ recordId, isDisabled, onClick, correctionSelected }) => {
    const { study } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();

    return (
        <Authorization studyId={study.id} currentPermissions={currentUserPermissions} permissionId={PermissionEnum.RequestMiscDCF}>
            <li
                className="col-md-6"
                style={{ paddingLeft: 5 + "px", paddingRight: 5 + "px" }}
                onClick={isDisabled ? null : onClick}>
                <input type="radio" name={`Misc${recordId}`} value="true" checked={correctionSelected} readOnly disabled={isDisabled} />
                <label>
                    <span className="posh-select-icon"><i className="fa fa-edit" aria-hidden="true"></i></span>
                    <span className="posh-select-body">
                        <span className="posh-select-title">Request another type of change</span>
                        <span className="posh-select-description text-muted">Request any other corrections that are not covered by other actions.</span>
                    </span>
                </label>
            </li>
        </Authorization>
    );
}
